import { Routes } from '@angular/router';
import { authGuard } from './core/providers/guards/auth.guard';
import { unAuthGuard } from './core/providers/guards/unauth.guard';
import { onboardingGuard } from './core/providers/guards/onboarding.guard';
import { adminGuard } from './core/providers/guards/admin.guard';

export const routes: Routes = [
  {
    path: "login",
    canActivate: [unAuthGuard],
    loadComponent: () => import('./feature/login/login').then(m => m.Login)
  },
  {
    path: "onboarding",
    canActivate: [onboardingGuard],
    loadComponent: () => import('./feature/onboarding/onboarding').then(m => m.OnboardingComponent)
  },
  {
    path: "ranking",
    canActivate: [authGuard],
    loadComponent: () => import('./feature/ranking/ranking').then(m => m.Ranking),
    data: { animation: 0 }
  },
  {
    path: "discover",
    canActivate: [authGuard],
    loadComponent: () => import('./feature/discover/discover').then(m => m.Discover),
    data: { animation: 1 }
  },
  {
    path: "account",
    canActivate: [authGuard],
    loadComponent: () => import('./feature/account/account').then(m => m.Account),
    data: { animation: 2 }
  },
  {
    path: "account/likes/:id",
    canActivate: [authGuard],
    loadComponent: () => import('./feature/account/liked-suggestion-detail/liked-suggestion-detail').then(m => m.LikedSuggestionDetail),
    data: { animation: 2 }
  },
  {
    path: "premium",
    canActivate: [authGuard],
    loadComponent: () => import('./feature/premium/premium').then(m => m.PremiumLanding),
    data: { animation: 2 }
  },
  {
    path: "settings",
    canActivate: [authGuard],
    loadComponent: () => import('./feature/settings/settings').then(m => m.Settings),
    data: { animation: 2 }
  },
  {
    path: "admin",
    canActivate: [adminGuard],
    loadChildren: () => import('./feature/admin/admin.routes').then(m => m.adminRoutes),
    data: { animation: 2 }
  },
  { path: "**", redirectTo: 'discover' },
];
